import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from './templates/main.jsx';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            hover: false,
            isMobile: window.innerWidth <= 960,
            isTablet: window.innerWidth <= 1360 && window.innerWidth > 960,
            isDesktop: window.innerWidth > 1360
        };

        return this;
    }

    updateWidth = () => {
        this.setState({
            isMobile: window.innerWidth <= 960,
            isTablet: window.innerWidth <= 1360 && window.innerWidth > 960,
            isDesktop: window.innerWidth > 1360
        });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    }

    navigate = (...args) => {
        return this.context.app.navigate(...args);
    };

    isActive = name => {
        return name === this._getActive();
    };

    _getActive() {
        const loc = this.context.history.location.pathname.split('/');

        return loc[1];
    }

    _getSubActive() {
        return this.context.history.location.hash
            ? this.context.history.location.pathname + this.context.history.location.hash
            : this.context.history.location.pathname;
    }

    static displayName = 'Header';

    static contextTypes = {
        app: PropTypes.object,
        history: PropTypes.object
    };
}
